import _ from 'lodash';
import React, { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const AutoCompleteControl = ({ field,
    value,
    textValuePairs,
    onChange,
    onBlur,
    className,
    disabled,
    loading,
    props,
    'aria-invalid': ariaInvalid,
    'aria-describedby': ariaDescribedBy,
}) => {
    const [defaultValue] = useState(value);

    // MUI's Autocomplete already implements the WAI-ARIA combobox pattern
    // (role="combobox", aria-expanded, aria-owns/aria-controls linking to the
    // listbox, and full keyboard support), so no additional ARIA wiring is
    // needed beyond correct labeling via the associated TextField.
    return (
        <Autocomplete
            disablePortal
            id={`field_ac_${field.FieldName}`}
            autoSelect
            isOptionEqualToValue={(option, value) => {
                return value.Value === option.Value;
            }}
            defaultValue={defaultValue}
            disabled={disabled}
            onChange={(context, value) => onChange(value, field)}
            options={_.map(textValuePairs ? textValuePairs : [], textValue => ({ label: textValue.Text, ...textValue }))}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField id={"field_txp_" + field.FieldName}
                {...params}
                {...(field.IsRequired && { required: true })}
                {...(((field.IsRequired && !value) || (field.validateMessage && field.blur)) && field.isDirty && { error: true })}
                label={field.DisplayName}
                placeholder={field.PlaceHolder}
                onBlur={(context) => onBlur ? onBlur(context, field) : null}
                variant="standard"
                disabled={disabled}
                className={className}
                error={ariaInvalid ?? params.error}
                inputProps={{ ...params.inputProps, 'aria-invalid': ariaInvalid, 'aria-describedby': ariaDescribedBy }}
                {...props} />} />
    )

}

export default AutoCompleteControl;